// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#recruitment-contact-edit[data-v-07e1c60a]{max-width:700px;margin-left:auto;margin-right:auto}#recruitment-contact-edit .approved-name[data-v-07e1c60a]{height:27px;margin-bottom:4px;font-size:18px;font-weight:700}#recruitment-contact-edit .cancel-btn[data-v-07e1c60a],#recruitment-contact-edit .update-btn[data-v-07e1c60a]{width:120px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
